import { useField } from 'formik';
import { ChangeEvent, ComponentType } from 'react';

import { Props } from './types';

export function withField<P>(Component: ComponentType<P>) {
  const NewComponent = (props: P & Props) => {
    const [field, { touched, error }] = useField(props);

    const hasError = touched && error;

    const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
      field.onChange(event);
      if (props.onChange) props.onChange(event);
    };

    return (
      <Component
        {...field}
        {...props}
        onChange={handleChange}
        hint={hasError ? error : ''}
        state={hasError ? 'error' : 'default'}
      />
    );
  };

  return NewComponent;
}
